import { createContext, useContext } from 'react';
import {
  PreparationTimeType,
  usePreparationTime,
} from './preparation-time-calendar/preparation-time.hooks';
import { StoreOrderingForm } from 'api/ordering-service/ordering-service.types';
import {
  OrderLimitsCalendarType,
  useOrderLimits,
} from './order-limits-calendar/order-limits.hooks';

export type KitchenCapacityContextType = {
  preparationTime: PreparationTimeType;
  orderLimits: OrderLimitsCalendarType;
};

export const KitchenCapacityContext = createContext<
  KitchenCapacityContextType | undefined
>(undefined);

export const useKitchenCapacityContext = () => {
  const context = useContext(KitchenCapacityContext);

  /* istanbul ignore next */
  if (!context)
    throw new Error(
      'useKitchenCapacityContext must be used within a KitchenCapacityContextProvider',
    );

  return context;
};

type KitchenCapacityProviderType = {
  children: React.ReactNode;
  storeOrderingData: StoreOrderingForm;
};

const KitchenCapacityProvider = ({
  children,
  storeOrderingData,
}: KitchenCapacityProviderType) => {
  const preparationTime = usePreparationTime({ storeOrderingData });
  const orderLimits = useOrderLimits({ storeOrderingData });

  const kitchenCapacityContextValue = {
    preparationTime,
    orderLimits,
  };

  return (
    <KitchenCapacityContext.Provider value={kitchenCapacityContextValue}>
      {children}
    </KitchenCapacityContext.Provider>
  );
};

export default KitchenCapacityProvider;
